import { createSelector } from 'reselect';

const selectCurrencies = (state: any) => state.currencies;


export const selectCurrentItem = createSelector([selectCurrencies], (currencies) => currencies.current);

export const selectListItems = createSelector([selectCurrencies], (currencies) => currencies.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCreatedItem = createSelector([selectCurrencies], (currencies) => currencies.create);

export const selectUpdatedItem = createSelector([selectCurrencies], (currencies) => currencies.update);

export const selectReadItem = createSelector([selectCurrencies], (currencies) => currencies.read);

export const selectDeletedItem = createSelector([selectCurrencies], (currencies) => currencies.delete);

export const selectSearchedItems = createSelector([selectCurrencies], (currencies) => currencies.search);

export const selectItemsCount = createSelector([selectCurrencies], (currencies) => currencies.count);

export const selectItemsFilter = createSelector([selectCurrencies], (currencies) => currencies.filter);